import type { ComponentType, ReactNode } from "react";
import { useMobileUiV1State } from "../../hooks/use-media-query";
import { DesktopOnlyNotice } from "./desktop-only-notice";

/**
 * One boundary for routes outside the agreed phone workflows. The desktop
 * subtree is not mounted on phones, so editor effects and mutation hooks stay
 * inactive without creating a second route presenter.
 */
export function desktopOnlyRoute(Component: ComponentType): () => ReactNode {
  return function DesktopOnlyRoute() {
    const { presenter } = useMobileUiV1State();

    if (presenter === "desktop") return <Component />;

    return (
      <div className="mx-auto max-w-lg px-4 py-8">
        <DesktopOnlyNotice
          minimumWidth={presenter === "below-minimum" ? 360 : undefined}
        />
      </div>
    );
  };
}
